var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54126 5.99805C5.62329 5.99805 5.70142 5.98242 5.77563 5.95117C5.84985 5.91602 5.91626 5.86523 5.97485 5.79883L10.2346 1.45117C10.3479 1.33398 10.4045 1.19727 10.4045 1.04102C10.4045 0.931641 10.3792 0.833984 10.3284 0.748047C10.2776 0.658203 10.2073 0.587891 10.1174 0.537109C10.0315 0.486328 9.93384 0.460938 9.82446 0.460938C9.66821 0.460938 9.52759 0.517578 9.40259 0.630859L5.25415 4.88477H5.82251L1.66821 0.630859C1.55103 0.517578 1.41235 0.460938 1.2522 0.460938C1.14282 0.460938 1.04321 0.486328 0.953369 0.537109C0.867432 0.587891 0.799072 0.658203 0.748291 0.748047C0.69751 0.833984 0.672119 0.931641 0.672119 1.04102C0.672119 1.12305 0.687744 1.19922 0.718994 1.26953C0.750244 1.33594 0.79126 1.39648 0.842041 1.45117L5.09595 5.80469C5.22876 5.93359 5.3772 5.99805 5.54126 5.99805Z",
    fill: "#142529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBold);
export default __webpack_public_path__ + "static/media/arrow-down-bold.e8c6ad4f6291bc6c12cb85c905501c9e.svg";
export { ForwardRef as ReactComponent };